/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import {stringToBoolean} from '@ion/core/src/utils/BooleanUtils';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {dlsColor} from '@ion/dls/src/theme/theme';

// defines the component styles ...
const useStyles = makeStyles(theme => ({
  labelContainer : {
    height         : '100%',
    width          : '40px',
    display        : 'flex',
    justifyContent : 'left',
    alignItems     : 'center',
    fontSize       : '10px',
    fontWeight     : 500
  },
  labelStyle : {
    color           : dlsColor('caRed'),
    backgroundColor : 'rgba(226, 35, 26, 0.1)',
    lineHeight      : '16px',
    width           : '100%',
    display         : 'flex',
    justifyContent  : 'center',
    padding         : '4px 6px',
    borderRadius    : '2px'
  }
}));

export const EOLTooltip = function(props) {
  return <Tooltip arrow {...props} />;
};

export type EolCellProps = {
  value: string
};

export const EolCell = ({value = ''}: EolCellProps) => {
  const classes = useStyles();
  const isEolDevice = value ? stringToBoolean(value) : false;
  return (
    isEolDevice ? (
      <EOLTooltip title={translate('admin-devices:grid.columns.eolTooltip')}>
        <div className={classes.labelContainer}>
          <div className={classes.labelStyle}>
            {translate('admin-devices:grid.columns.eol')}
          </div>
        </div>
      </EOLTooltip>
    ) : <div />
  );
};

export default memo(EolCell);
